module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-list"
  }, [_c('div', {
    staticClass: "items-section"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item._id,
      staticClass: "item-container",
      style: (_vm.itemContainerStyle)
    }, [_c('div', {
      staticClass: "item-row clickable",
      class: {
        selected: item._selected, hover: item == _vm.hoveredItem, expanded: item == _vm.expandedItem
      }
    }, [_c('div', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      staticClass: "item-title",
      on: {
        "click": function($event) {
          return _vm.itemClicked(item)
        }
      }
    }, [_c('div', {
      staticClass: "item-check-column",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleSelection(item)
        }
      }
    }, [(item._selected) ? _c('v-icon', [_vm._v("check_box")]) : _c('v-icon', [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('div', {
      staticClass: "item-text-column",
      on: {
        "mouseenter": function($event) {
          return _vm.itemHovered(item)
        },
        "mouseleave": function($event) {
          return _vm.itemNotHovered(item)
        }
      }
    }, [_vm._t("title", [_vm._v("\n                                " + _vm._s(item.name) + "\n                            ")], {
      "item": item
    })], 2), _vm._v(" "), (!_vm.hideExpander) ? _c('div', {
      staticClass: "item-button-column"
    }, [_c('v-btn', {
      attrs: {
        "color": "grey darken-1",
        "icon": "",
        "text": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.buttonClicked(item)
        },
        "mousedown": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-icon', [_vm._v("arrow_drop_down")])], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-content"
    }, [(item == _vm.expandedItem) ? _c('div', [_vm._t("content", [_c('div', {
      staticStyle: {
        "padding": "10px",
        "font-size": "14px",
        "color": "#ccc"
      }
    }, [_vm._v("\n                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero nam animi fugiat consequatur neque ea natus. Velit commodi porro modi excepturi consequatur ex, debitis, perferendis error earum deserunt inventore odit!\n                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero nam animi fugiat consequatur neque ea natus. Velit commodi porro modi excepturi consequatur ex, debitis, perferendis error earum deserunt inventore odit!\n                            ")])], {
      "item": item
    })], 2) : _vm._e()])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e6b230d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/OneOrMoreList.vue
// module id = 2619
// module chunks = 1